import ForgotPasswordCtrl from './controllers/forgotPasswordController.js';
const moduleName = 'forgotPassword';
angular.module(moduleName, []).controller('ForgotPasswordCtrl', ForgotPasswordCtrl);
export default moduleName;